import * as React from "react";
import Component from "../../AbstractComponent";
import Dropzone from "react-dropzone";
import { AttachmentInterface } from "../../../Entity/Entities/Attachment/AttachmentInterface";
import Constants from "../../../Action/Constants";
import AttachmentFactory from "../../../Entity/Factories/AttachmentFactory";
import * as uuidV4 from "uuid/v4";
import Card from '@material-ui/core/Card';
import LinearProgress from '@material-ui/core/LinearProgress';
import Button from '@material-ui/core/Button';
import { TableComponent } from "../../Partials/Table/TableComponent";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import CasedeskUrl from "../../../Url/Url";

class Attachment extends Component {
  protected fileInput;
  protected allowedFileTypes: string[] = [
    "image/jpeg",
    "image/jpg",
    "image/bmp",
    "image/png",
    "application/pdf",
    "application/msword", // doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
  ];

  protected allowedFileTypesForLogo: string[] = [
    "image/jpeg",
    "image/jpg",
    "image/png",
  ];

  protected maximumFileSize: number = 10485760; // 10MB
  protected amazonFolderName: string = uuidV4();
  protected entity = null;

  public componentStyles = {
    tileBackground: "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,.5) 100%)",
    iconColor: "#fff",
    documentIconColor: "#cc0000"
  };

  public state: {
    attachments: AttachmentInterface[],
    selectedAttachment: AttachmentInterface,
    showSlider: boolean,
    sliderAttachment: AttachmentInterface,
    hidePrev: boolean,
    hideNext: boolean,
    dragging: boolean,
    openExtensionsDialog: boolean,
    extensionDialogReason: string,
    isAttachmentDeletePopupOpen: boolean,
    entity: any,
    anchorEl: any,
    selectedAttachmentsIds: any;
    isFetchingFile: boolean;
    isDownloadFileError: boolean;
    isGridAttachmentsViews: boolean;
    renderDropZone: boolean;
    activateDropZone: boolean;
    setNoChangeViewFlag: boolean;
  } = {
    attachments: [],
    selectedAttachment: null,
    showSlider: false,
    sliderAttachment: null,
    hidePrev: true,
    hideNext: true,
    dragging: false,
    openExtensionsDialog: false,
    extensionDialogReason: "",
    isAttachmentDeletePopupOpen: false,
    entity: null,
    anchorEl: null,
    selectedAttachmentsIds: [],
    isFetchingFile: false,
    isDownloadFileError: false,
    isGridAttachmentsViews: false,
    renderDropZone: true,
    activateDropZone: false,
    setNoChangeViewFlag: false
  };

  constructor(public props) {
    super(props);
    if (typeof this.props.amazonFolderName !== "undefined" && this.props.amazonFolderName !== null) {
      this.amazonFolderName = this.props.amazonFolderName;
    }

    document.addEventListener("keydown", this.handleKeyPress.bind(this));
    document.addEventListener("dragenter", this.activateDropZone.bind(this));
    document.addEventListener("drop", this.deActivateDropZone.bind(this));

    this.fileInput = React.createRef();
  }

  public componentWillMount() {
    if (typeof this.props.attachments !== "undefined") {
      const selectedAttachmentsIds = this.props.selectedAttachmentsIds ? this.props.selectedAttachmentsIds : this.props.attachments?.filter(attachment => attachment?.automaticallyCreated)?.map(attachment => attachment.id);

      if (!this.props.setNoChangeViewFlag){
        if (this.props.attachments?.length > 0 && this.props.attachments.find((attachment: AttachmentInterface) => !!attachment?.cropImgPath) ){
          this.setState({isGridAttachmentsViews: true})
        } else {
          this.setState({isGridAttachmentsViews: false})
        }
      }

      this.setState({
        attachments: this.props.attachments,
        selectedAttachmentsIds: selectedAttachmentsIds,
        entity: this.props.entity
      }, () => {
        this.detectAvatar(true);
      });
    }

    // we should generate amazonFolderName if attachment component is on create entity name
    if (typeof this.props.onAmazonFolderNameGeneration !== "undefined") {
      if( !this.amazonFolderName) {
        this.props.onAmazonFolderNameGeneration.call(this, this.amazonFolderName);
      }
    }
  }

  public componentWillReceiveProps(nextProps) {
    this.setState({
      entity: nextProps.entity
    });

    if (typeof nextProps.attachments !== "undefined") {
      if (!nextProps.setNoChangeViewFlag){
        if (nextProps.attachments?.length > 0 && nextProps.attachments.find((attachment: AttachmentInterface) => !!attachment?.cropImgPath)){
          this.setState({isGridAttachmentsViews: true})
        } else {
          this.setState({isGridAttachmentsViews: false})
        }
      }

      this.setState({
        attachments: AttachmentFactory.createFromArray(nextProps.attachments),
      }, () => {
           //this.detectAvatar(false);
      });
    }
    if (typeof nextProps.attachmentIds !== "undefined") {
      this.setState({
        selectedAttachmentsIds: [...nextProps.selectedAttachmentsIds]
      });
    }
  }

  public updateParentState = (attachments) => {
    if (typeof this.props.updateParentState === "function") {
      this.props.updateParentState.call(this, attachments);
    }
  }

  public getEntityId = (): null | number => {
    if (!this.state.entity) {
      return null;
    }

    return this.state.entity.id;
  }

  public getImages = (): AttachmentInterface[] => {
    return this.state.attachments.filter(
      (attachment: AttachmentInterface) => !!attachment && attachment.extension &&
                                            attachment.extension.indexOf("image/") !== -1
    );
  }

  protected openMenu = (event: any, attachment: AttachmentInterface): void => {
    this.setState({
      selectedAttachment: attachment,
      anchorEl: event.currentTarget
    });
  }


  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public onAttachmentsRowSelection = (_event, attachment): void => {
    const { selectedAttachmentsIds } = this.state;
    const id = attachment.id;
    const selectedIndex = selectedAttachmentsIds.indexOf(id);

    let newSelectedIds = []; //Array of Id new selected attachments

    if (selectedIndex === -1) {
      newSelectedIds = newSelectedIds.concat(selectedAttachmentsIds, id);
    } else if (selectedIndex === 0) {
      newSelectedIds = newSelectedIds.concat(selectedAttachmentsIds.slice(1));
    } else if (selectedIndex === selectedAttachmentsIds.length - 1) {
      newSelectedIds = newSelectedIds.concat(selectedAttachmentsIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedIds = newSelectedIds.concat(
        selectedAttachmentsIds.slice(0, selectedIndex),
        selectedAttachmentsIds.slice(selectedIndex + 1),
      );
    }

    this.setState({
      selectedAttachmentsIds: newSelectedIds
     }, () => {
       if (typeof this.props.onAttachmentSelect === "function") {
           this.props.onAttachmentSelect.call(this, newSelectedIds);
        }
     });
  }

  public isSelected = id => this.state.selectedAttachmentsIds.indexOf(id) !== -1;

  public renderSelectableAttachments = () => {
    const allAttachments = this.state.attachments;

    return allAttachments
    .map((attachment: AttachmentInterface, index: number) => {
      const isSelected = this.isSelected(attachment.id);

      return (
        <TableRow
          hover
          key={index}
          className={`clickable-entity`}
          onClick={!!attachment.cropImgPath ? this.openSlider.bind(this, attachment) : () => window.open(CasedeskUrl.getAttachment(attachment?.path, attachment?.filename), "_blank")}
          tabIndex={-1}
          aria-checked={isSelected}
          selected={isSelected}
          role="checkbox"
        >
          <TableCell 
            padding="checkbox"
            onClick={event => {event.stopPropagation(); this.onAttachmentsRowSelection(event, attachment);}}
            style={{width: "30px"}}
          >
            <Checkbox
              checked={isSelected}
              color="primary"
            />
          </TableCell>
          <TableCell style={{width: "15%", padding: "0 0 0 5px"}}>
            <div style={{display: "flex", alignItems: "center", justifyContent: "center", width: "80px" }}>
            { !!attachment.cropImgPath
              ?
              <img className="selectable-attachment-image"
                src={CasedeskUrl.getAttachment(attachment?.cropImgPath)}
                onClick={this.openSlider.bind(this, attachment)}
              />
              :
              <img className="selectable-attachment-image icon-link"
                src={CasedeskUrl.getAttachment(attachment?.iconLink)}
              />
            }

            </div>
          </TableCell> 
          <TableCell style={{width: "65%"}}>{attachment?.filename}</TableCell>
          <TableCell style={{width: "20%"}}>{this.formatter.formatDate(new Date(attachment?.createdAt))}</TableCell>
        </TableRow>
      );
    });
  }

  public downloadFileByUrl(attachment) {
    if(!attachment){
      return;
    }

    this.setState({
      isFetchingFile: true,
      setNoChangeViewFlag: true
    })
    return fetch(CasedeskUrl.getAttachment(attachment?.path)).then(res => res.blob()) // Gets the response and returns it as a blob
      .then(blob => {
        // Here's where you get access to the blob
        // And you can use it for whatever you want
        this.setState({
          isFetchingFile: false
        })
        let objectURL = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = objectURL;
        a.download = attachment.filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    })
    .catch(error => {
      this.setState({
        isDownloadFileError: !!error,
        isFetchingFile: false
      })
    });
  }


  public renderAttachments = () => {
    const allAttachments = this.state.attachments.length > 0 && this.state.attachments;

    if(allAttachments && allAttachments.length > 0) {
      return allAttachments
      .map((attachment: AttachmentInterface, index: number) => {
        return (
          <TableRow
            hover
            key={index}
            className={`clickable-entity`}
            onClick={!!attachment.cropImgPath ? this.openSlider.bind(this, attachment) : () => window.open(CasedeskUrl.getAttachment(attachment?.path, attachment?.filename), "_blank")}
          >
            <TableCell>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center", width: "80px"}}>
              {!!attachment.cropImgPath
                ?
                <img className="new-attachment-image"
                  src={CasedeskUrl.getAttachment(attachment?.cropImgPath)}
                  onClick={this.openSlider.bind(this, attachment)}
                />
                :
                <img className="new-attachment-image icon-link"
                  src={CasedeskUrl.getAttachment(attachment?.iconLink)}
                />
              }
              </div>
            </TableCell>
            <TableCell style={{width: "80%"}}>{attachment?.filename}</TableCell>
            <TableCell style={{width: "15%"}}>{this.formatter.formatDate(new Date(attachment?.createdAt))}</TableCell>
            <TableCell style={{width: "5%"}}>
              {this.renderAttachmentListAvatarIcon(attachment)}
            </TableCell>
              <TableCell
                onClick={e => {
                  e.stopPropagation();
                }}
              >
                <div>
                  <IconButton
                    onClick={e => this.openMenu(e, attachment)}
                  >
                    <div className="icon icon-ic-more-vert"></div>
                  </IconButton>
                  <Menu
                    id="simple-menu"
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl) && this.state.selectedAttachment?.id === attachment.id}
                    onClose={this.closeMenu}
                    disableAutoFocusItem={true}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center"
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left"
                    }}
                    getContentAnchorEl={null}
                  >
                    { this.state.selectedAttachment?.cropImgPath !== "" && this.props.possibilityToSetAvatar && // You can set avatar on Unit page, on Property page but for task page it's not possible (set value possibility Set Avatar = false if it's not possible)
                      <MenuItem
                        onClick={e => {
                          if(this.props.disabled){
                            this.props.dispatch({
                              type: Constants.SNACKBAR_ADD_MESSAGE,
                              payload: {
                                message: this.trans("preprocess/cantupdateentity-info"),
                                type: "error"
                              }
                            });
                      
                            return;
                          }
                          e.preventDefault(); this.setState({anchorEl: null}); this.setAvatar(this.state.selectedAttachment, true); }
                        }
                      >
                        <ListItemIcon>
                          {
                            this.props.possibilityToSetAvatar && this.state.selectedAttachment?.isAvatar && this.state.selectedAttachment?.cropImgPath !== "" && this.state.selectedAttachment?.cropImgPath ?
                            <div className="icon icon-ic-star"></div> 
                            : this.props.possibilityToSetAvatar && this.state.selectedAttachment?.cropImgPath !== "" && this.state.selectedAttachment?.cropImgPath &&
                            <div className="icon icon-ic-star-border"></div>
                          }
                        </ListItemIcon>
                        <ListItemText>{this.trans("menu/attachment-option/setavatar")}</ListItemText>
                      </MenuItem>
                    }
                    <MenuItem
                      onClick={() => {
                        if(this.props.disabled){
                          this.props.dispatch({
                            type: Constants.SNACKBAR_ADD_MESSAGE,
                            payload: {
                              message: this.trans("preprocess/cantupdateentity-info"),
                              type: "error"
                            }
                          });
                    
                          return;
                        }
                        this.setState({anchorEl: null}); this.downloadFileByUrl(this.state.selectedAttachment)}
                      }
                    >
                      <ListItemIcon><div className="icon icon-ic-download aligned"></div></ListItemIcon>
                      <ListItemText>{this.trans("menu/attachment-option/download")}</ListItemText>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        if(this.props.disabled){
                          this.props.dispatch({
                            type: Constants.SNACKBAR_ADD_MESSAGE,
                            payload: {
                              message: this.trans("preprocess/cantupdateentity-info"),
                              type: "error"
                            }
                          });
                    
                          return;
                        }
                        this.setState({isAttachmentDeletePopupOpen: true, anchorEl: null})}
                      }
                    >
                      <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                      <ListItemText>{this.trans("menu/payment-option/remove")}</ListItemText>
                    </MenuItem>
                  </Menu>
                </div>
            </TableCell>
          </TableRow>
        );
      });
    }
  }

  public uploadAttachments = (e) => {
    return this.handleAttachments(e.target.files);
  }

  public onDrop = (acceptedFiles: any[]): void => {
    this.setState({
      dragging: false
    });

    if(this.props.doNotAllowAddAttachment) {
      return;
    }

    return this.handleAttachments(acceptedFiles);
  }

  public handleAttachments = (attachments) => {
    if(this.props.disabled){
      this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("preprocess/cantupdateentity-info"),
          type: "error"
        }
      });
      
      return;
    }
    this.setState({
      setNoChangeViewFlag: false
    });
    const promises = [];
    // FormData is not an array so we have to iterate using for loops.
    for (let i = 0; i < attachments.length; i++) {
      if (!attachments[i]) {
        continue;
      }

      promises.push(this.promisifyAttachments(attachments[i]));
    }

    this.props.dispatch({
      type: Constants.LOADING_SHOW
    });

    this.drainPromises(promises);
  }

  public isFileTypeValid = (fileType: string, file): boolean => {
    if(this.props.coachPresentation) {
      return this.allowedFileTypesForLogo.filter(type => type === fileType).length === 1;
    } else {
      return this.allowedFileTypes.filter(type => type === fileType).length === 1 || (file.name.indexOf('.docx') !== -1);
    }
  }

  public promisifyAttachments = (file) => {
    if (file.size >= this.maximumFileSize) {
      this.setState({openExtensionsDialog: true, extensionDialogReason: `${this.trans("wrong-file-size")} [${this.maximumFileSize/1024/1024 } MB].`});
      return new Error(`File size is bigger than maximum allowed value ${this.maximumFileSize}.`);
    }
    
    if (this.isFileTypeValid(file.type, file) === false) {
      this.setState({openExtensionsDialog: true, extensionDialogReason: this.props.coachPresentation ? this.trans("wrong-file-type-logo") : this.trans("wrong-file-type")});

      return new Error("File mime type is not allowed.");
    }

    return new Promise(accept => {
      const reader = new FileReader();

      reader.onload = () => {
        const attachment: AttachmentInterface = AttachmentFactory.create({
          extension: file.type,
          name: file.name,
          path: reader.result,
          fileInstance: file,
          uuid: uuidV4(),
          isPrivate: false 
        });

        return accept([attachment, file]);

      };
      reader.readAsDataURL(file);
    });
  }

  /*
  |  This is a recursive function because native JS promises does not support concurrency
  |  when you try to use Promise.all
  |  We're faking this functionality ourself.
  */
  public drainPromises = (promises: Array<Promise<any>>): any => {
    if (promises.length === 0) {
      this.props.dispatch({
        type: Constants.LOADING_HIDE
      });
      return;
    }

    return Promise.all([promises.pop()])
      .then(res => {
        const attachment = res[0][0];
        const file = res[0][1];
        return this.create(attachment, file);
      })
      .then(() => {
        return this.drainPromises(promises);
      });
  }

  protected createS3path = (fileName, attachmentType?: string) => {
    let path: string = "";
    switch (attachmentType) {
      case "avatar":
        path = `attachments/${this.amazonFolderName}/entityAvatars/${fileName}`;
      break;
      case "img":
        path = `attachments/${this.amazonFolderName}/croppedImages/${fileName}`;
      break;
      default:
        path = `attachments/${this.amazonFolderName}/${fileName}`;
      break;
    }
    return path;
  }

  protected create = (attachment: AttachmentInterface, file: File) => {
    return new Promise<void>((accept, reject) => {
      // if some file was deleted we should skip it and continue download next files
      if (!file || (file && file.size === 0)) {
        return accept();
      }
      this.props.disableButtons && this.props.disableButtons(true);
      this.props.dispatch({
        type: Constants.GLOBAL_ATTACHMENT_UPLOAD_START,
        payload: {
          attachmentData: {
            attachment: attachment,
            file: file,
            amazonFolderName: this.amazonFolderName,
            amazonAttachmentPath: this.createS3path(file?.name),
            amazonAvatarPath: this.createS3path(file?.name, "avatar"),
            amazonCropImgPath:  this.createS3path(file?.name, "img"),
            relation: this.props.relation,
            entityId: this.getEntityId(),
            isPrivate: false
          },
          typeOfComponent: this.props.typeOfComponent
        },
        onSuccess: (data: AttachmentInterface | AttachmentInterface[]) => {
          this.fileInput.value = null;
          let attachments;

          if (!Array.isArray(data)) {
            attachments = this.state.attachments.concat(data);
          } else {
            attachments = data;
          }

          if (this.props.logoComponent) {
            const avatar = attachments[attachments?.length - 1];
            this.setAvatar(avatar, true, attachments);
          } else {
            this.updateParentState(attachments);
            this.props.disableButtons && this.props.disableButtons(false);
            this.detectAvatar(true);
          }

          return accept();
        },
        onError: () => {
          return reject();
        }
     });
   });
  }

  public delete = () => {
    const id = this.state.selectedAttachment?.id;
    const attachments: AttachmentInterface[] = AttachmentFactory.createFromArray(this.state.attachments);
    this.setState({
      setNoChangeViewFlag: true
    });
    this.props.disableButtons && this.props.disableButtons(true);
    return this.props.dispatch({
      type: Constants.GLOBAL_ATTACHMENT_DELETE_START,
      payload: {
        id: id,
        entityId: this.getEntityId(),
        entityType: this.props.relation,
        entity: this.state.entity,
        attachments: attachments
      },
      onSuccess: () => {
        // Update the avatars
        this.setState({
          isAttachmentDeletePopupOpen: false,
        }, () => {
          // If we deleted the attachment, we should update attachments is state in parent component.
          this.updateParentState(this.state.attachments.filter((attachment: AttachmentInterface) => attachment.id !== id));
          this.props.disableButtons && this.props.disableButtons(false);

          // If we deleted the last attachment, we should put the initial icon back.
          if (this.getImages().length === 0 && typeof this.props.onLastImageDeleted === "function") {
            this.props.onLastImageDeleted.call(this);
          }

          this.detectAvatar(true);
        });
      }
    });
  }

  public closeAttachmentDeletePopup = (): void => {
    this.setState({
      isAttachmentDeletePopupOpen: false
    })
  }

  public detectAvatar = (dispatch): void => {
    // If we don't have any images, then just return.
    if (this.getImages().length === 0) {
      return;
    }

    // Check if we have any avatars which has isAvatar attribute true.
    const filtered = this.state.attachments?.filter((attachment: AttachmentInterface) => attachment.isAvatar);

    // If we have an avatar with isAvatar true, then it is the avatar we're going to be using.
    if (filtered.length > 0) {
      this.setAvatar(filtered[0], dispatch);
      return;
    }
    
    // Otherwise, the first element in the array will always be the avatar.
    this.setAvatar(this.getImages()[0], dispatch);
  }

  public setAvatar = (avatar: AttachmentInterface, dispatch, attachmentsParams?: AttachmentInterface[]): void => { 
    const attachmentsArr = attachmentsParams || this.state.attachments;

    if (typeof this.props.onChangeAvatar !== "undefined") {
      this.props.onChangeAvatar.call(this, avatar);
    }

    if (!dispatch || avatar?.isAvatar) {
      return;
    }
    this.props.disableButtons && this.props.disableButtons(true);
    // Remove isAvatar from all of the attachments.
    const attachments = attachmentsArr.map(attachment => {
      return attachment?.reinitialize({ isAvatar: false })
    });
    const newAvatar = avatar.reinitialize({ isAvatar: true });
    // Merge both arrays
    const merged = attachments.map((attachment: AttachmentInterface) => {
      if (attachment.id === avatar.id) {
        return newAvatar;
      }

      return attachment;
    });
    
    this.setState({
      setNoChangeViewFlag: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_SET_AVATAR_START,
        payload: {
          entityId: this.getEntityId(),
          relation: this.props.relation,
          entity: this.props.entity,
          avatar: newAvatar,
          attachments: merged
        },
        onSuccess: () => {
          this.updateParentState(merged);
          this.props.disableButtons && this.props.disableButtons(false);
        }
      });
    });
  }

  public getDropzoneNotice = (): any => {
    return <h3>{this.trans("title-dropzone-upload-notice")}</h3>;
  }

  public openSlider = (attachmentParam: AttachmentInterface): void => {
    const index: number = this.getImages().findIndex(attachment => attachment.id === attachmentParam.id);

    this.setState({
      showSlider: true,
      sliderAttachment: attachmentParam,
      hidePrev: typeof this.getImages()[index - 1] === "undefined",
      hideNext: typeof this.getImages()[index + 1] === "undefined"
    });
  }

  public closeSlider = (): void => {
    this.setState({
      showSlider: false,
      sliderAttachment: null,
      hidePrev: true,
      hideNext: true
    });
  }

  public prev = (): void => {
    const images: AttachmentInterface[] = this.getImages();
    if (!this.state.sliderAttachment) { return; };
    const index: number = images.findIndex(attachment => attachment.id === this.state.sliderAttachment.id);
    this.openSlider(images[index - 1]);
  }

  public next = (): void => {
    const images: AttachmentInterface[] = this.getImages();
    if (!this.state.sliderAttachment) { return; };
    const index: number = images.findIndex(attachment => attachment.id === this.state.sliderAttachment.id);
    this.openSlider(images[index + 1]);
  }

  public handleKeyPress = (e) => {
    switch (e.keyCode) {
      case 27:
        this.closeSlider();
        break;
      case 37:
        this.prev();
        break;
      case 39:
        this.next();
        break;
      default:
        return;
    }
  };

  public activateDropZone = () => {
    this.setState({
      activateDropZone: true
    })
  }

  public deActivateDropZone = () => {
    this.setState({
      activateDropZone: false
    })
  }

  public renderAttachmentListAvatarIcon = (attachment) => {
    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        {attachment && (
          <span>
            {
              this.props.possibilityToSetAvatar && attachment?.isAvatar && attachment.cropImgPath !== "" && attachment.cropImgPath ?
              <div className="icon icon-ic-star" onClick={e => {e.stopPropagation(); this.setState({anchorEl: null}); this.setAvatar(attachment, true); }}></div> 
              : this.props.possibilityToSetAvatar && attachment?.cropImgPath !== "" && attachment?.cropImgPath &&
              <div className="icon icon-ic-star-border" onClick={e => {e.stopPropagation(); this.setState({anchorEl: null}); this.setAvatar(attachment, true); }}></div>
            }
          </span>
          )
        }
      </div>
    );
  }

  public renderSelectableContent = () => {
    return (
      <div>
        {this.state.attachments.length > 0 && (
          <div>
            <div className="attachment-component">
              <div></div>
              {this.state.showSlider === true && (
                <div className="attachment-slider"
                  onClick={this.closeSlider}
                  style={{ display: this.state.showSlider === true ? "block" : "none" }}
                >
                  <div className="image-container"
                    onClick={e => e.stopPropagation()}
                  >
                    <img className="attachment-image" src={CasedeskUrl.getAttachment(this.state.sliderAttachment?.path)}/>
                    <div
                      className="prev-container"
                      style={{ display: this.state.hidePrev === true ? "none" : "block" }}
                      onClick={this.prev}
                    >
                      <div className="icon icon-ic-keyboard-arrow-left"></div>
                    </div>
                    <div
                      className="next-container"
                      style={{ display: this.state.hideNext === true ? "none" : "block" }}
                      onClick={this.next}
                    >
                      <div className="icon icon-ic-keyboard-arrow-right"></div>
                    </div>
                    <div
                      className="close-container"
                      onClick={this.closeSlider}
                    >
                      <div className="icon icon-ic-close"></div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        <TableComponent
          {...this.props}
          className="listing-table attachments-table with-first-border"
          rows={this.renderSelectableAttachments()}
        />
      </div>
    )
  }


  public renderSharedContent = () => {
    const allAttachments = this.state.attachments.length > 0 && this.state.attachments;

    return (
      <div style={{position: "relative"}}>
        {
          this.props.hint && (
            <div style={{fontSize: "14px", color: "gray", margin: "5px 0 10px 65px"}}>
              {this.props.hint}
            </div>
          )
        }

        <Dropzone
          className={`dropzone ${this.state.dragging ? "dragging-active" : ""} ${this.state.activateDropZone ? "main-view" : ""} ${!allAttachments || allAttachments?.length === 0 ? "without-attachments-view" : "with-attachments-view"} ${this.props.coachPresentation && (!allAttachments || allAttachments?.length === 0) ? "agency-coach-logo" : ""}`}
          activeClassName="dropzone active"
          acceptClassName="dropzone accept"
          rejectClassName="dropzone reject"
          disabledClassName="dropzone disabled"
          disableClick={true}
          onDragEnter={() => this.setState({ dragging: true })}
          onDragLeave={() => this.setState({ dragging: false})}
          onDrop={this.onDrop}
        >
          {this.state.attachments.length > 0 && (
            <div>
              <div className="attachment-component">
                <div></div>
                {this.state.showSlider === true && (
                  <div className="attachment-slider"
                    onClick={this.closeSlider}
                    style={{ display: this.state.showSlider === true ? "block" : "none" }}
                  >
                    <div className="image-container"
                      onClick={e => e.stopPropagation()}
                    >
                      <img className="attachment-image" src={CasedeskUrl.getAttachment(this.state.sliderAttachment?.cropImgPath)}/>
                      <div
                        className="prev-container"
                        style={{ display: this.state.hidePrev === true ? "none" : "block" }}
                        onClick={this.prev}
                      >
                        <div className="icon icon-ic-keyboard-arrow-left"></div>
                      </div>
                      <div
                        className="next-container"
                        style={{ display: this.state.hideNext === true ? "none" : "block" }}
                        onClick={this.next}
                      >
                        <div className="icon icon-ic-keyboard-arrow-right"></div>
                      </div>
                      <div
                        className="close-container"
                        onClick={this.closeSlider}
                      >
                        <div className="icon icon-ic-close"></div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {this.getDropzoneNotice()}
        </Dropzone>

        <LinearProgress
          className="progress-bar"
          style={{ display: this.props.app.isUploadingSharedAttachment ? "block" : "none" }}
          variant="indeterminate"
        />
        {
          this.state.isGridAttachmentsViews ? 
          <div className={`grid-list ${this.props.conversationView ? "converstaion-view" : ""}`}>
            <GridList 
              cellHeight={200} 
              cols={3}  
              style={{display: "flex", justifyContent: this.props.coachPresentation ? "center" : "flex-start"}}
            >
              {allAttachments?.length > 0 && allAttachments.map((attachment) => (
                <GridListTile style={{cursor: "pointer"}} cols={1}>
                  {attachment.cropImgPath !== "" && attachment.cropImgPath ?
                    <img src={CasedeskUrl.getAttachment(attachment?.cropImgPath)} onClick={this.openSlider.bind(this, attachment)} alt={attachment.filename} />
                    :
                    <img
                      className="icon-link-grid"
                      onClick={() => window.open(CasedeskUrl.getAttachment(attachment?.path), "_blank")}
                      src={CasedeskUrl.getAttachment(attachment?.iconLink)}
                    />
                  }
                  {
                    this.props.possibilityToSetAvatar && attachment.isAvatar && attachment.cropImgPath !== "" && attachment.cropImgPath && !this.props.disabled ?
                    <div className="icon icon-ic-star" onClick={e => {e.preventDefault(); this.setState({anchorEl: null}); this.setAvatar(attachment, true); }}></div> 
                    : this.props.possibilityToSetAvatar && attachment.cropImgPath !== "" && attachment.cropImgPath && !this.props.disabled ?
                    <div className="icon icon-ic-star-border" onClick={e => {e.preventDefault(); this.setState({anchorEl: null}); this.setAvatar(attachment, true); }}></div>
                    :
                    <div></div>
                  }
                  <GridListTileBar
                    title={attachment.filename}
                    titlePosition="top"
                    actionIcon={
                      <div>
                      <IconButton
                        onClick={e => this.openMenu(e, attachment)}
                      >
                      <div className="icon icon-ic-more-vert"></div>
                      </IconButton>
                      <Menu
                        id="simple-menu"
                        anchorEl={this.state.anchorEl}
                        open={Boolean(this.state.anchorEl) && this.state.selectedAttachment?.id === attachment.id}
                        onClose={this.closeMenu}
                        disableAutoFocusItem={true}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center"
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left"
                        }}
                        getContentAnchorEl={null}
                      >
                        { this.state.selectedAttachment?.cropImgPath !== ""  && this.props.possibilityToSetAvatar && // You can set avatar on Unit page, on Property page but for task page it's not possible (set value possibility Set Avatar = false if it's not possible)
                          <MenuItem
                            onClick={e => {
                              if(this.props.disabled){
                                this.props.dispatch({
                                  type: Constants.SNACKBAR_ADD_MESSAGE,
                                  payload: {
                                    message: this.trans("preprocess/cantupdateentity-info"),
                                    type: "error"
                                  }
                                });
                          
                                return;
                              }
                              e.preventDefault(); this.setState({anchorEl: null}); this.setAvatar(this.state.selectedAttachment, true); }
                            }
                          >
                            <ListItemIcon>
                              {
                                this.props.possibilityToSetAvatar && this.state.selectedAttachment?.isAvatar && this.state.selectedAttachment?.cropImgPath !== "" && this.state.selectedAttachment?.cropImgPath ?
                                <div className="icon icon-ic-star"></div> 
                                : this.props.possibilityToSetAvatar && this.state.selectedAttachment?.cropImgPath !== "" && this.state.selectedAttachment?.cropImgPath &&
                                <div className="icon icon-ic-star-border"></div>
                              }
                          </ListItemIcon>
                            <ListItemText>{this.trans("menu/attachment-option/setavatar")}</ListItemText>
                          </MenuItem>
                        }
                        <MenuItem
                          onClick={() => {
                            if(this.props.disabled){
                              this.props.dispatch({
                                type: Constants.SNACKBAR_ADD_MESSAGE,
                                payload: {
                                  message: this.trans("preprocess/cantcreateactivitytemplate-info"),
                                  type: "warning"
                                }
                              });
                        
                              return;
                            }
                            this.setState({anchorEl: null}); this.downloadFileByUrl(this.state.selectedAttachment)}
                          }
                        >
                          <ListItemIcon><div className="icon icon-ic-download aligned"></div></ListItemIcon>
                          <ListItemText>{this.trans("menu/attachment-option/download")}</ListItemText>
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            if(this.props.disabled){
                              this.props.dispatch({
                                type: Constants.SNACKBAR_ADD_MESSAGE,
                                payload: {
                                  message: this.trans("preprocess/cantcreateactivitytemplate-info"),
                                  type: "warning"
                                }
                              });
                        
                              return;
                            }
                            this.setState({isAttachmentDeletePopupOpen: true, anchorEl: null})}}
                        >
                          <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                          <ListItemText>{this.trans("menu/payment-option/remove")}</ListItemText>
                        </MenuItem>
                      </Menu>
                    </div>
                    }
                    actionPosition="right"
                    className="title-bar"
                  />
                </GridListTile>
              ))}
            </GridList>
          </div>
          :
          <TableComponent
            {...this.props}
            className="listing-table attachments-table with-first-border"
            rows={this.renderAttachments()}
          />
        }
      </div>
    )
  }

  public render() {
    return (
      <div className={`component attachments-main-wrapper ${this.props.isCardView ? "attachments-editable-section" : ""}`} style={{marginBottom: this.props.withoutBottomMargin ? "0" : "20px"}}>
        {
          this.state.isFetchingFile && (
            <div className="component-spinner-wrapper">
              <CircularProgress />
            </div>
          )
        }
        <Card className="card">
          <div className={`label-container ${this.props.conversationView ? "attachment-title" : ""} ${this.props.logoComponent ? "reset-styles" : ""}`}
            style={{
              display: "flex",
              justifyContent: this.props.coachPresentation ? "center" : "space-between"
            }}
          >
            <div             
              style={{display: "flex"}}
            >
              {
                this.props.typeOfComponent !== "selectable" &&  !this.props.coachPresentation && (
                  <div style={{position: "absolute", top: "16px", left: "20px", cursor: "pointer"}} onClick={() => {this.setState({isGridAttachmentsViews: !this.state.isGridAttachmentsViews})}}>
                    {this.state.isGridAttachmentsViews ?
                      <div className="icon icon-ic-view-list icon-view-switcher"></div>
                      :
                      <div className="icon icon-ic-view-module icon-view-switcher"></div>
                    }
                  </div>
                )
              }

              {
                !this.props.coachPresentation &&
                <h3 className="card-title">
                  {this.props.title || this.trans("attachments")}
                </h3>
              }
            </div>

            { ((this.props.typeOfComponent !== "selectable" && !this.props.doNotAllowAddAttachment && !this.props.logoComponent) || (this.props.logoComponent && this.state.attachments?.length === 0)) &&
            <div>
              <input
                type="file"
                accept={`${ this.props.coachPresentation ? ".jpg,.jpeg,.png" : ".bmp,.jpg,.jpeg,.png,.doc,.docx,.pdf"}`}
                style={{
                  display: "none"
                }}
                multiple={!this.props.logoComponent}
                onChange={this.uploadAttachments}
                onClick={(event)=> { 
                  event.currentTarget.value = null
                }}
                
                disabled={this.props.app.isUploadingSharedAttachment || this.props.app.isUploadingPrivateAttachment || this.props.disabled}
                id="button-file"
                ref={this.fileInput}
              />
              <label htmlFor="button-file">
                <Button
                  style={{
                    height: this.props.isCardView ? "75%" : "100%"
                  }}
                  color="primary"
                  variant={this.props.isCardView ? "outlined" : "text"}
                  className={"new-attachment-button"}
                  disabled={this.props.app.isUploadingSharedAttachment || this.props.app.isUploadingPrivateAttachment}
                  onClick={() => {
                    if(this.props.disabled){
                      this.props.dispatch({
                        type: Constants.SNACKBAR_ADD_MESSAGE,
                        payload: {
                          message: this.trans("preprocess/cantcreateactivitytemplate-info"),
                          type: "warning"
                        }
                      });
                
                      return;
                    }
                    this.fileInput.current.click()}
                  }
                >
                  {this.props.logoComponent ? this.trans("button-add-logo") : this.props.buttonTitle || this.trans("button-add-attachment")}
                </Button>
              </label>
            </div>
            }
          </div>
          <div className={`${!this.state.isGridAttachmentsViews && this.state.attachments?.length > 0 ? "list-view" : "grid-view" } attachment-component-container`}>
            {this.props.typeOfComponent === "selectable" && this.renderSelectableContent()}
            {this.props.typeOfComponent === "shared" && this.renderSharedContent()}
          </div>
        </Card>

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          content={
            <p>{this.state.extensionDialogReason}</p>
          }
          positiveButtonLabel={this.trans("button-close")}
          onlyPositiveButton={true}
          openLeavePrompt={this.state.openExtensionsDialog}
          prioritizeClosing={true}
          onSave={() => this.setState({ openExtensionsDialog: false })}
        />

        <PromptDialog
          {...this.props}
          content={
            <p>{this.trans("error-attachment-download-response-was-failed")}</p>
          }
          positiveButtonLabel={this.trans("button-close")}
          onlyPositiveButton={true}
          openLeavePrompt={this.state.isDownloadFileError}
          prioritizeClosing={true}
          onSave={() => this.setState({ isDownloadFileError: false })}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'attachment-remove-page-content-dialog'}
          isOpen={this.state.isAttachmentDeletePopupOpen}
          onCancel={this.closeAttachmentDeletePopup}
          onDelete={this.delete}
        />
      </div>
    );
  }
}

export { Attachment };
